module.exports = __webpack_public_path__ + "static/media/h&rblock.c99024ec.png";